import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { pickLang } from '../../content.jsx';
import { postDate } from '../../news.js';
import NotFound from './NotFound.jsx';

// /news/:slug — one post. Body is rich text sanitized on the server.
export default function NewsPost() {
  const { slug } = useParams();
  const { t, lang } = useI18n();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    let alive = true;
    setPost(null); setMissing(false);
    const preview = new URLSearchParams(window.location.search).get('preview') === '1';
    const load = preview ? api(`/posts/${encodeURIComponent(slug)}?preview=1`)
      : fetch(`/api/posts/${encodeURIComponent(slug)}`, { cache: 'no-cache' }).then((r) => (r.ok ? r.json() : Promise.reject(r)));
    load.then((p) => alive && setPost(p)).catch(() => alive && setMissing(true));
    return () => { alive = false; };
  }, [slug]);
  useEffect(() => { if (post) document.title = `${pickLang(post.title, lang)} | ${t('brand.name')}`; }, [post, lang, t]);
  if (missing) return <NotFound />;
  if (!post) return <div className="page-loading">{t('common.loading')}</div>;
  return (
    <article className="news-article">
      {post.preview && post.status !== 'published' && <div className="preview-banner">👁 {t('news.draftPreview')}</div>}
      <div className="container news-article-inner">
        <p><Link to="/news" className="back-link">← {t('news.back')}</Link></p>
        <p className="news-meta"><span className="news-cat">{t(`news.categories.${post.category || 'news'}`)}</span> · {postDate(post.publishedAt, lang)}</p>
        <h1>{pickLang(post.title, lang)}</h1>
        {pickLang(post.excerpt, lang) && <p className="news-lead">{pickLang(post.excerpt, lang)}</p>}
        {post.cover && <img className="news-cover" src={post.cover} alt="" decoding="async" />}
        <div className="rich-text news-body" dangerouslySetInnerHTML={{ __html: pickLang(post.body, lang) }} />
      </div>
    </article>
  );
}
